import { Box, Typography } from "@mui/material";
import BackGroundImage from "../../assets/svg/auth-bg.svg";
import { Login } from "../../features/auth/pages/Login";
import { Navigate, Route, Routes } from "react-router-dom";
import { SignUp } from "../../features/auth/pages/SignUp";
import { Forgot } from "../../features/auth/pages/Forgot";
import { ConfirmEmail } from "../../features/auth/pages/ConfirmEmail";
import { ResetPassword } from "../../features/auth/pages/ResetPassword";
import { useTranslation } from "react-i18next";

export const AuthTemplate = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flex: "1 1 auto",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          background: "rgb(28, 37, 54)",
          backgroundImage: `url(${BackGroundImage})`,
          display: { sm: "none", md: "flex", xs: "none" },
          flex: "1",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          alignItems: "center",
          justifyContent: "center",
          padding: "32px",
        }}
      >
        <Box sx={{ maxWidth: "800px", alignSelf: "center" }}>
          <Typography color={"white"} variant="h4" mb={"4px"}>
            {t("auth.description_1")}
          </Typography>
          <Typography color={"rgb(108, 115, 127)"}>
            {t("auth.description_2")}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          width: "450px",
          background: "rgb(255, 255, 255)",
          padding: "64px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot" element={<Forgot />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Box>
    </Box>
  );
};
